export default __webpack_public_path__ + "a837bf1ddd8819f86a5e8fc9b4ddbc3a.png";